import {createSvgIcon} from '../create-svg-icon';

export const SignalCellularConnectedNoInternet0BarIcon = createSvgIcon(
  <path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z" />
, 'SignalCellularConnectedNoInternet0BarOutlined');
